import {lemon, lemonReady} from "../common/lemon";
import {fetchPost} from "../common/fetch";
import {isEmptyList, noty_confirm2, noty_error, url} from "../common/common";
import {buildNoResult, buildPageNavigation} from "../mypage/common/_mypage_navi";
import {concatName, concatNameKana} from "../common/utils/concat_utils";
import {deleteBizUser} from "../mypage/bizuser/_bizuser_trans";

lemonReady(function (){
    getNewsList(0);
});


function getNewsList(page = 0, is_reload= true) {
    //showLoader();
    // ---------------------------
    // 検索条件作成・検索実行
    // ---------------------------
    let sendData = {};
    sendData["page_index"] = page;
    fetchPost({
        action: "/api/news/list",
        data: sendData,
    })
        .then((data) => {
            // ------------------
            // 検索成功・一覧作成
            // ------------------
            buildNewsList(data);
        })
        .catch((reason) => {
            // error
            console.error(reason);
            noty_error(reason);
        })
        .finally(() => {
            // finally
            //hideLoader();
            if(is_reload){
                window.scrollTo(0,0);
            }
        });
}
const NEWS_LIST_ITEM = `
<div class="news-list_item">
  <a href="article01">
    <p class="data">2022.12.01</p>
    <h2 class="news-title">年末年始の営業のお知らせ</h2>
    <span class="arow">
    <svg viewBox="0 0 16.14 9.07">
      <use xlink:href="#arow"></use>
    </svg>
  </span>
  </a>
</div>            
`;
function buildNewsList(data){
    let list_wrap = lemon("#newsList");
    list_wrap.empty();
    let list = data.item_list;
    let list_count = 0;
    let result_count = 0;
    if (!isEmptyList(list)) {
        result_count = list.length;
        list_count = data.pager_navi.item_count;
        for (let elem of list) {
            list_wrap.append(createNewsListItem(elem));
        }
    }
    console.log(data.pager_navi);
    // ----------------------
    // paging, list count
    // ----------------------
    if(list_count > 1){
        buildPageNavigation(data, getNewsList);
    }else{
        buildNoResult();
    }
    //lemon(".result-count").text(result_count);
    //lemon(".total-count").text(list_count);
}

function createNewsListItem(newsDto){
    let itemTemplate = document.createElement('div');
    itemTemplate.innerHTML = NEWS_LIST_ITEM;
    let newsListItem = lemon(itemTemplate).find(".news-list_item");
    newsListItem.find(".data").text(newsDto["news_date"]);
    newsListItem.find(".news-title").text(newsDto["title"]);
    newsListItem.find("a").attr("href", url("/news/detail?p=" + newsDto["news_id_enc"]));
    return newsListItem;
}